import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ShowProcessComponent } from '@modules/shared/components/show-process/show-process.component';

@NgModule({
	declarations: [ShowProcessComponent],
	exports: [ShowProcessComponent],
	imports: [CommonModule],
})
export class ShowProcessModule {}
